import { render, staticRenderFns } from "./reviewhouse.vue?vue&type=template&id=50352e40&scoped=true&"
import script from "./reviewhouse.vue?vue&type=script&lang=js&"
export * from "./reviewhouse.vue?vue&type=script&lang=js&"
import style0 from "./reviewhouse.vue?vue&type=style&index=0&id=50352e40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50352e40",
  null
  
)

export default component.exports